const resources = {
  en: {
    notifications: {
      title: 'Notifications',
      description: 'Important system observations and reminders that need your attention.',
      empty: 'No notifications here right now.',
      emptyValue: 'Not available',
      loadFailed: 'Failed to load notifications',
      actionFailed: 'Failed to update notification',
      reminderCreateFailed: 'Failed to create reminder',
      reminderCreateSuccess: 'Reminder created',
      open: 'Open',
      updatedAt: 'Updated {{date}}',
      dueAt: 'Due {{date}}',
      snoozedUntil: 'Snoozed until {{date}}',
      itemFallbackTitle: 'Notification',
      itemFallbackBody: 'Review this item when you have time.',
      summary: {
        visibleUnread: 'Unread',
        visibleHigh: 'Needs action',
        visibleCritical: 'Critical',
      },
      filters: {
        status: {
          active: 'Active',
          unread: 'Unread',
          read: 'Read',
          snoozed: 'Snoozed',
          dismissed: 'Dismissed',
          resolved: 'Resolved',
        },
        category: {
          all: 'All categories',
          goal: 'Goals',
          task: 'Tasks',
          billing: 'Billing',
          forecast: 'Forecast',
          security: 'Security',
          system: 'System',
        },
        type: {
          all: 'All notification types',
          user_reminder: 'My reminders',
          goal_without_plan: 'Goals without plan',
          goal_behind_plan: 'Goals behind plan',
          missed_commitment: 'Missed commitments',
          commitment_due_today: 'Due today',
          billing_payment_issue: 'Billing issues',
        },
        severity: {
          all: 'All severity levels',
          info: 'Info',
          warning: 'Warning',
          critical: 'Critical',
        },
      },
      severity: {
        info: 'Info',
        warning: 'Warning',
        critical: 'Critical',
      },
      status: {
        unread: 'Unread',
        read: 'Read',
        dismissed: 'Dismissed',
        resolved: 'Resolved',
        snoozed: 'Snoozed',
      },
      category: {
        goal: 'Goal',
        task: 'Task',
        billing: 'Billing',
        forecast: 'Forecast',
        security: 'Security',
        system: 'System',
      },
      taskTypes: {
        task: 'task',
        recurrent_expense: 'recurring expense',
        recurrent_income: 'recurring income',
        goal_contribution: 'goal contribution',
        debt_payment: 'debt payment',
        repayment_plan: 'payment plan task',
        manual: 'manual task',
      },
      actions: {
        createReminder: 'Create reminder',
        read: 'Mark read',
        dismiss: 'Dismiss',
        snooze: 'Snooze 1 day',
        readSuccess: 'Notification marked read',
        dismissSuccess: 'Notification dismissed',
        snoozeSuccess: 'Notification snoozed',
      },
      reminderForm: {
        title: 'Create a reminder',
        description: 'Add a lightweight note to your inbox. It does not change transactions, tasks, forecast, or push settings.',
        titlePlaceholder: 'What should you remember?',
        bodyPlaceholder: 'Optional note',
        dueAtPlaceholder: 'Optional due date',
        titleRequired: 'Reminder title is required',
      },
      items: {
        userReminder: {
          title: 'Reminder: {{title}}',
          body: '{{body}}',
          cta: 'Open reminder',
        },
        goalWithoutPlan: {
          title: 'Financial goal has no plan',
          body: 'You created “{{goalTitle}}”, but there is no contribution plan yet. The system can track the target, but cannot judge whether you are on pace.',
          cta: 'Create plan',
        },
        goalBehindPlan: {
          title: 'Financial goal is behind plan',
          body: '“{{goalTitle}}” is behind the contribution plan. You have reached about {{actualPercent}}% of what should be set aside by now.',
          cta: 'Review goal',
        },
        missedCommitment: {
          title: 'Missed task',
          body: '“{{taskTitle}}” was due on {{promisedForLocalDate}} and still needs your decision. Confirm it if it happened, or cancel it if it should be skipped.',
          cta: 'Review task',
        },
        commitmentDueToday: {
          title: 'Task due today',
          body: '“{{taskTitle}}” is due today. Confirm it if it happened, or cancel it if it should be skipped.',
          cta: 'Review task',
        },
        billingPaymentIssue: {
          title: 'Payment needs attention',
          body: 'Your {{plan}} subscription is currently {{subscriptionStatus}}. Open billing history to review the latest payment status and recovery actions.',
          cta: 'Open billing',
        },
      },
    },
  },
  uk: {
    notifications: {
      title: 'Сповіщення',
      description: 'Важливі системні сигнали та нагадування, які потребують вашої уваги.',
      empty: 'Зараз тут немає сповіщень.',
      emptyValue: 'Немає даних',
      loadFailed: 'Не вдалося завантажити сповіщення',
      actionFailed: 'Не вдалося оновити сповіщення',
      reminderCreateFailed: 'Не вдалося створити нагадування',
      reminderCreateSuccess: 'Нагадування створено',
      open: 'Відкрити',
      updatedAt: 'Оновлено {{date}}',
      dueAt: 'Термін {{date}}',
      snoozedUntil: 'Відкладено до {{date}}',
      itemFallbackTitle: 'Сповіщення',
      itemFallbackBody: 'Перегляньте це, коли буде зручно.',
      summary: {
        visibleUnread: 'Непрочитані',
        visibleHigh: 'Потребують дії',
        visibleCritical: 'Критичні',
      },
      filters: {
        status: {
          active: 'Активні',
          unread: 'Непрочитані',
          read: 'Прочитані',
          snoozed: 'Відкладені',
          dismissed: 'Приховані',
          resolved: 'Вирішені',
        },
        category: {
          all: 'Усі категорії',
          goal: 'Цілі',
          task: 'Задачі',
          billing: 'Оплати',
          forecast: 'Прогноз',
          security: 'Безпека',
          system: 'Система',
        },
        type: {
          all: 'Усі типи сповіщень',
          user_reminder: 'Мої нагадування',
          goal_without_plan: 'Цілі без плану',
          goal_behind_plan: 'Цілі відстають від плану',
          missed_commitment: 'Пропущені зобов’язання',
          commitment_due_today: 'На сьогодні',
          billing_payment_issue: 'Проблеми з оплатою',
        },
        severity: {
          all: 'Усі рівні важливості',
          info: 'Інфо',
          warning: 'Увага',
          critical: 'Критично',
        },
      },
      severity: {
        info: 'Інфо',
        warning: 'Увага',
        critical: 'Критично',
      },
      status: {
        unread: 'Непрочитане',
        read: 'Прочитане',
        dismissed: 'Приховане',
        resolved: 'Вирішене',
        snoozed: 'Відкладене',
      },
      category: {
        goal: 'Ціль',
        task: 'Задача',
        billing: 'Оплати',
        forecast: 'Прогноз',
        security: 'Безпека',
        system: 'Система',
      },
      taskTypes: {
        task: 'задача',
        recurrent_expense: 'регулярна витрата',
        recurrent_income: 'регулярний дохід',
        goal_contribution: 'поповнення цілі',
        debt_payment: 'платіж за боргом',
        repayment_plan: 'задача з плану виплат',
        manual: 'ручна задача',
      },
      actions: {
        createReminder: 'Створити нагадування',
        read: 'Позначити прочитаним',
        dismiss: 'Приховати',
        snooze: 'Відкласти на 1 день',
        readSuccess: 'Сповіщення позначено прочитаним',
        dismissSuccess: 'Сповіщення приховано',
        snoozeSuccess: 'Сповіщення відкладено',
      },
      reminderForm: {
        title: 'Створити нагадування',
        description: 'Додайте коротку нотатку у свій inbox. Це не змінює транзакції, задачі, прогноз або push-налаштування.',
        titlePlaceholder: 'Що потрібно пам’ятати?',
        bodyPlaceholder: 'Необов’язкова нотатка',
        dueAtPlaceholder: 'Необов’язкова дата',
        titleRequired: 'Потрібна назва нагадування',
      },
      items: {
        userReminder: {
          title: 'Нагадування: {{title}}',
          body: '{{body}}',
          cta: 'Відкрити нагадування',
        },
        goalWithoutPlan: {
          title: 'Фінансова ціль без плану',
          body: 'Ви створили “{{goalTitle}}”, але ще не додали план поповнень. Система бачить ціль, але не може чесно оцінити, чи ви йдете за графіком.',
          cta: 'Створити план',
        },
        goalBehindPlan: {
          title: 'Фінансова ціль відстає від плану',
          body: '“{{goalTitle}}” відстає від плану поповнень. Зараз виконано приблизно {{actualPercent}}% від того, що мало бути накопичено на цей момент.',
          cta: 'Переглянути ціль',
        },
        missedCommitment: {
          title: 'Пропущена задача',
          body: '“{{taskTitle}}” була запланована на {{promisedForLocalDate}} і досі очікує вашого рішення. Підтвердіть її, якщо дія відбулася, або скасуйте, якщо її потрібно пропустити.',
          cta: 'Переглянути задачу',
        },
        commitmentDueToday: {
          title: 'Задача на сьогодні',
          body: '“{{taskTitle}}” запланована на сьогодні. Підтвердіть її, якщо дія відбулася, або скасуйте, якщо її потрібно пропустити.',
          cta: 'Переглянути задачу',
        },
        billingPaymentIssue: {
          title: 'Оплата потребує уваги',
          body: 'Ваша підписка {{plan}} зараз має статус {{subscriptionStatus}}. Відкрийте історію оплат, щоб переглянути останній статус платежу та дії для відновлення.',
          cta: 'Відкрити оплату',
        },
      },
    },
  },
  ru: {
    notifications: {
      taskTypes: {
        task: 'задача',
        recurrent_expense: 'регулярный расход',
        recurrent_income: 'регулярный доход',
        goal_contribution: 'пополнение цели',
        debt_payment: 'платёж по долгу',
        repayment_plan: 'задача из плана выплат',
        manual: 'ручная задача',
      },
      items: {
        missedCommitment: {
          title: 'Просроченная задача',
          body: '“{{taskTitle}}” была запланирована на {{promisedForLocalDate}} и всё ещё ждёт решения. Подтвердите её, если действие было выполнено, или отмените, если её нужно пропустить.',
          cta: 'Открыть задачу',
        },
        commitmentDueToday: {
          title: 'Задача на сегодня',
          body: '“{{taskTitle}}” запланирована на сегодня. Подтвердите её, если действие было выполнено, или отмените, если её нужно пропустить.',
          cta: 'Открыть задачу',
        },
      },
    },
  },
}

export default resources
